import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { FolderOpen, Receipt, LogOut, Loader2, Menu } from "lucide-react";
import { useState } from "react";

const navItems = [
  { to: "/admin/accountant/bookkeeping", label: "Dokument", icon: FolderOpen },
];

export default function AccountantLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (loading) return <div className="min-h-screen bg-[#0A1628] flex items-center justify-center"><Loader2 className="w-6 h-6 text-[#F59073] animate-spin" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role !== "accountant") return <Navigate to="/admin/dashboard" replace />;

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  const SidebarContent = () => (
    <>
      <div className="p-6 border-b border-[#1E3050]">
        <span className="font-outfit font-medium text-white text-lg tracking-tight">wedowedo</span>
        <p className="font-mono text-[10px] tracking-[0.2em] text-[#857973] mt-1">BOKFÖRING</p>
      </div>
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} onClick={() => setSidebarOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors ${isActive ? "bg-[#F59073]/10 text-[#F59073]" : "text-[#857973] hover:text-white hover:bg-[#1E3050]/50"}`
            }>
            <Icon className="w-4 h-4" /> {label}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-[#1E3050]">
        <div className="text-xs text-[#857973] font-manrope mb-3 px-3">{user?.name || user?.email}</div>
        <button onClick={handleLogout}
          className="flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm text-[#857973] hover:text-red-400 hover:bg-red-500/5 transition-colors w-full">
          <LogOut className="w-4 h-4" /> Logga ut
        </button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-[#0A1628] flex">
      <aside className="hidden lg:flex w-60 flex-col bg-[#0F1F3A] border-r border-[#1E3050] fixed inset-y-0 left-0 z-30">
        <SidebarContent />
      </aside>
      {sidebarOpen && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div className="absolute inset-0 bg-black/60" onClick={() => setSidebarOpen(false)} />
          <aside className="absolute left-0 top-0 bottom-0 w-60 bg-[#0F1F3A] border-r border-[#1E3050] flex flex-col z-50">
            <SidebarContent />
          </aside>
        </div>
      )}
      <div className="flex-1 lg:ml-60">
        <header className="sticky top-0 z-20 bg-[#0A1628]/80 backdrop-blur-xl border-b border-[#1E3050] h-14 flex items-center px-6 gap-4">
          <button onClick={() => setSidebarOpen(true)} className="lg:hidden text-white"><Menu className="w-5 h-5" /></button>
          <div className="flex-1" />
          <span className="text-xs text-[#857973] font-mono tracking-wider">BOKFÖRARE</span>
        </header>
        <main className="p-6 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
